import Component from '@glimmer/component';
import type { EmberChangeset } from 'ember-changeset';
import FormyField from './field';
import FormyComponent from '../formy';
import FuiSearch from 'parog-web/components/fui-search';
import { hash, concat } from '@ember/helper';
import changesetSet from 'ember-changeset/helpers/changeset-set';
import changesetGet from 'ember-changeset/helpers/changeset-get';

type Args = (
  | { parent: FormyComponent; key: string }
  | { parent: FormyField; key: never }
) & { source: Array<{ title: string }>; searchDelay?: number };

interface Signature {
  Args: Args;
}

export default class FormySearchComponent extends Component<Signature> {
  get changeset(): EmberChangeset {
    return this.#formy.args.changeset;
  }

  get key(): string {
    return this.args.parent instanceof FormyField
      ? this.args.parent.args.key
      : this.args.key;
  }

  get #formy(): FormyComponent {
    if (this.args.parent instanceof FormyComponent) return this.args.parent;
    return this.args.parent.args.formy;
  }

  <template>
    <FuiSearch
      @settings={{hash
        onSelect=(changesetSet this.changeset this.key)
        source=@source
        searchDelay=@searchDelay
      }}
      @selected={{changesetGet this.changeset (concat this.key '.title')}}
    />
  </template>
}
